import React from "react";
import Card from "../../features/ui/Card";
import { CrownIcon } from "../../primatives/Icons";
import Spinner from "./Spinner";

export default function CurrentGradeCard({
  title = "Current Grade",
  displayText,
  subText,
  onSave,
  onImport,
  importLocked = false,
  onRequestPro,
  disabled,
  calculateLoading = false,
}) {
  const onClickImport = () => {
    if (importLocked) {
      onRequestPro?.();
      return;
    }
    onImport?.();
  };

  const isDisabled = disabled || calculateLoading;

  return (
    <Card className="relative p-6">
      {/* Loading overlay */}
      {calculateLoading ? (
        <div className="absolute inset-0 z-10 flex items-center justify-center rounded-2xl bg-white/60 dark:bg-neutral-950/60">
          <div className="inline-flex items-center gap-2 rounded-full border border-neutral-200 bg-white px-3 py-1 text-xs font-semibold text-neutral-700 dark:border-neutral-800 dark:bg-neutral-950 dark:text-neutral-200">
            <Spinner size={16} />
            Calculating…
          </div>
        </div>
      ) : null}

      <h3 className="text-base font-semibold text-neutral-900 dark:text-neutral-50">
        {title}
      </h3>

      <div className="mt-4 rounded-2xl border border-neutral-200 bg-white p-5 text-center dark:border-neutral-800 dark:bg-neutral-950">
        <div className={calculateLoading ? "opacity-70" : ""}>
          <div className="text-4xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-50">
            {displayText ?? "—"}
          </div>

          <div className="mt-2 text-sm text-neutral-600 dark:text-neutral-400">
            {subText ?? ""}
          </div>

          <div className="mt-4 flex items-center justify-center gap-2">
            <button
              type="button"
              onClick={onSave}
              disabled={isDisabled}
              className={
                isDisabled
                  ? "inline-flex items-center justify-center rounded-xl bg-neutral-200 px-4 py-2 text-sm font-semibold text-neutral-500 dark:bg-neutral-800 dark:text-neutral-500"
                  : "inline-flex items-center justify-center rounded-xl bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-500"
              }
            >
              Calculate
            </button>

            <button
              type="button"
              onClick={onClickImport}
              aria-disabled={importLocked}
              className="
                relative inline-flex items-center justify-center
                rounded-xl border border-neutral-200 bg-white px-4 py-2
                text-sm font-semibold text-neutral-800
                hover:bg-neutral-100
                dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-100 dark:hover:bg-neutral-800
              "
              title={importLocked ? "Pro feature" : "Import"}
            >
              Import

              {importLocked ? (
                <span
                  className="
                    pointer-events-none absolute -top-3 -right-5
                    inline-flex items-center gap-1
                    rounded-full bg-orange-500/15 px-2 py-0.5
                    text-[10px] font-semibold text-orange-600
                    ring-1 ring-orange-500/30
                    dark:text-orange-300
                  "
                >
                  <CrownIcon className="h-3 w-3" />
                  Pro
                </span>
              ) : null}
            </button>
          </div>
        </div>
      </div>
    </Card>
  );
}